module.exports = __webpack_public_path__ + "img/island-hopping-full-white-text.2e355fd0.svg";